<template>
  <div>
    <div class="maxcontent">
      <b-table
        :items="items"
        :fields="fields"
        id="offerTable"
        per-page="10"
        :current-page="page"
      >
        <template v-slot:cell(dataestq)="row">
          {{ convertDate(row.item.dataestq) }}
        </template>
        <template v-slot:cell(name)="row">
          {{ getDataContactName(row.item) }}
        </template>
        <template v-slot:cell(phone)="row">
          {{ getDataContactPhone(row.item) }}
        </template>
        <template v-slot:cell(createdAt)="row">
          {{ getDataCreatedAt(row.item) }}
        </template>
      </b-table>
    </div>
    <b-pagination
      v-model="page"
      :total-rows="total"
      per-page="10"
      aria-controls="offerTable"
    ></b-pagination>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';

export default {
  name: 'Oferta',
  data: () => ({
    items: [],
    fields: [
      { key: 'modelo', label: 'Modelo' },
      { key: 'up', label: 'Up' },
      { key: 'dataestq', label: 'Data Estoque' },
      { key: 'classe', label: 'Subsegmento' },
      { key: 'anomodelo', label: 'Ano Modelo' },
      { key: 'anofabricacao', label: 'Ano Fabricação' },
      { key: 'codigo_cor', label: 'Codigo Cor' },
      { key: 'cor', label: 'Cor' },
      { key: 'dealer', label: 'Concessionário' },
      { key: 'name', label: 'Nome Contato' },
      { key: 'phone', label: 'Telefone Contato' },
      { key: 'createdAt', label: 'Data Registro' },
    ],
    page: 1,
    total: 0,
  }),
  watch: {
    offers: function watchOffers() {
      this.items = [];
      setTimeout(() => {
        this.items = this.offers;
        this.total = this.items.length;
      }, 500);
    },
  },
  computed: {
    ...mapFields('stockOffer', ['offers', 'totalOffer']),
  },
  methods: {
    ...mapActions('stockOffer', ['getContactOffer', 'getStockOffer']),
    getDataContactName(stockItem) {
      if (stockItem.contacts) {
        return stockItem.contacts.nome;
      }
      return null;
    },
    getDataContactPhone(stockItem) {
      if (stockItem.contacts) {
        return stockItem.contacts.telefone;
      }
      return null;
    },
    getDataCreatedAt(stockItem) {
      if (stockItem.mystock_status) {
        return this.convertDate(stockItem.mystock_status.createdAt);
      }
      return null;
    },
    convertDate(date) {
      return (`${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`);
    },
  },
  async mounted() {
    /*
    await this.getStockOffer({
      filter: null,
    });
    this.items = this.offers;
    */
  },
};
</script>

<style>

</style>
